(function () {
  var triggerSelector = [
    'main[data-template*="product"] .jdgm-preview-badge',
    'main[data-template*="product"] .jdgm-prev-badge',
    'main[data-template*="product"] .jdgm-prev-badge__stars',
    'main[data-template*="product"] .jdgm-prev-badge__text',
    'main[data-template*="product"] .jdgm-star',
    'main[data-template*="product"] .rating-wrapper',
    'main[data-template*="product"] a[href="#judgeme_product_reviews"]',
    'main[data-template*="product"] a[href*="judgeme"]'
  ].join(',');

  function reviewSection() {
    return document.querySelector('.bf-review-proof:not([hidden]), [data-bf-review-proof]:not([hidden])');
  }

  function headerOffset() {
    var header = document.querySelector('#header-group');
    return header ? header.getBoundingClientRect().height : 0;
  }

  function scrollToReviews() {
    var section = reviewSection();
    if (!section) return false;

    var top = section.getBoundingClientRect().top + window.pageYOffset - headerOffset() - 18;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    return true;
  }

  function targetFromEvent(event) {
    if (!event.target || !event.target.closest) return null;
    var target = event.target.closest(triggerSelector);
    if (!target || !document.querySelector('main[data-template*="product"]')) return null;
    return target;
  }

  function decorate() {
    document.querySelectorAll(triggerSelector).forEach(function (trigger) {
      if (trigger.dataset.bfReviewJumpBound === 'true') return;
      trigger.dataset.bfReviewJumpBound = 'true';
      trigger.classList.add('bf-review-jump-trigger');
      trigger.style.cursor = 'pointer';

      if (!/^(A|BUTTON)$/i.test(trigger.tagName)) {
        trigger.setAttribute('role', 'button');
        trigger.setAttribute('tabindex', '0');
      }

      if (!trigger.getAttribute('aria-label')) {
        trigger.setAttribute('aria-label', 'Read product reviews');
      }
    });
  }

  document.addEventListener('click', function (event) {
    var target = targetFromEvent(event);
    if (!target) return;

    if (scrollToReviews()) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var target = targetFromEvent(event);
    if (!target) return;

    if (scrollToReviews()) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', decorate);
  } else {
    decorate();
  }

  window.setTimeout(decorate, 500);
  window.setTimeout(decorate, 1500);
  window.setTimeout(decorate, 3000);

  if ('MutationObserver' in window) {
    var observer = new MutationObserver(decorate);
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () {
      observer.disconnect();
    }, 7000);
  }
})();
